<template>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Entité:</label>
        </div>
        <div class="col-lg-9">
          <Dropdown
              class="input-width-100"
              v-model="entite"
              :options="entiteLibelles"
              optionValue="valeur"
              optionLabel="texte"
              v-on:keyup.enter="imprimer"
              scrollHeight="700px"
              :showClear="true"
              :disabled="cacherDropdown == true"
          />
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Site d'origine:</label>
        </div>
        <div class="col-lg-9">
          <Dropdown
              class="input-width-100"
              v-model="siteOrigine"
              :options="sitesLibelles"
              optionValue="valeur"
              optionLabel="texte"
              @:keyup.enter="imprimer"
              scrollHeight="205px"
              :showClear="true"
              :disabled="cacherDropdown == true"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Secteur:</label>
        </div>
        <div class="col-lg-9">
          <Dropdown
              class="input-width-100"
              v-model="secteur"
              :options="secteurLibelles"
              optionValue="valeur"
              optionLabel="texte"
              v-on:keyup.enter="imprimer"
              scrollHeight="700px"
              :showClear="true"
          />
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Regroupement:</label>
        </div>
        <div class="col-lg-9">
          <Dropdown
              class="input-width-100"
              v-model="regroupement"
              :options="regroupementLibelles"
              optionValue="valeur"
              optionLabel="texte"
              v-on:keyup.enter="imprimer"
              scrollHeight="700px"
              :showClear="true"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Genre:</label>
        </div>
        <div class="col-lg-9">
          <Dropdown
              class="input-width-100"
              v-model="genre"
              :options="genresLibelles"
              optionValue="valeur"
              optionLabel="texte"
              @:keyup.enter="imprimer"
              scrollHeight="205px"
              :showClear="true"
          />
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Intervenant:</label>
        </div>
        <div class="col-lg-9">
          <div v-if="intervenantsLoading == true" class="">
            <vue-loaders name="ball-beat"></vue-loaders>
          </div>
          <div v-else>
            <Dropdown
                class="input-width-100"
                inputClass="limit-width-intervenant"
                v-model="intervenant"
                :options="intervenantLibelles"
                optionValue="codeProfil"
                optionLabel="description"
                v-on:keyup.enter="imprimer"
                scrollHeight="700px"
                :showClear="true"
                filter
                filterPlaceholder="Rechercher..."
                filterMatchMode="startsWith"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Nature:</label>
        </div>
        <div class="col-lg-9">
          <Dropdown
              class="input-width-100"
              v-model="nature"
              :options="naturesLibelles"
              optionValue="valeur"
              optionLabel="texte"
              @:keyup.enter="imprimer"
              scrollHeight="205px"
              :showClear="true"/>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Endroit:</label>
        </div>
        <div class="col-lg-9">
          <Dropdown
              class="input-width-100"
              v-model="endroit"
              :options="endroitLibelles"
              optionValue="valeur"
              optionLabel="texte"
              v-on:keyup.enter="imprimer"
              scrollHeight="700px"
              :showClear="true"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Type:</label>
        </div>
        <div class="col-lg-9">
          <Dropdown
              class="input-width-100"
              v-model="type"
              :options="typeLibelles"
              optionValue="valeur"
              optionLabel="texte"
              v-on:keyup.enter="imprimer"
              scrollHeight="700px"
              :showClear="true"
          />
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Catégorie:</label>
        </div>
        <div class="col-lg-9">
          <Dropdown
              class="input-width-100"
              v-model="categorie"
              :options="categorieLibelles"
              optionValue="valeur"
              optionLabel="texte"
              v-on:keyup.enter="imprimer"
              scrollHeight="700px"
              :showClear="true"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Remphor entre le:</label>
        </div>
        <div class="col-lg-9">
          <CustomInputDate
              class="input-width-100"
              type="date"
              max="9999-12-31"
              v-model="dateDu"
              v-on:keyup.enter="imprimer"
          />
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>et le:</label>
        </div>
        <div class="col-lg-9">
          <CustomInputDate
              class="input-width-100"
              type="date"
              max="9999-12-31"
              v-model="dateAu"
              v-on:keyup.enter="imprimer"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {mapGetters} from "vuex";
import axios from "axios";
import CustomInputDate from '../../Commun/CustomInputDate.vue'

export default {
  name: "CritereRechercheRegroupement",
  emits: ['imprimer'],
  components: {
    CustomInputDate
  },
  props: {
    cacherDropdown: {
      type: Boolean,
      default: false,
    },
    entiteDefault: {
      type: Number,
      default: null,
    },
    siteDefault: {
      type: Number,
      default: null,
    },
  },
  mounted() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store.dispatch("narration/obtenirRegroupementAction").then((res) => {
      this.setRegroupement(res.data.secteur);
    });
  },
  data() {
    return {
      entite: null,
      siteOrigine: null,
      genre: null,
      nature: null,
      endroit: null,
      type: null,
      categorie: null,
      secteur: null,
      intervenant: null,
      dateDu: null,
      dateAu: null,
      regroupement: null,

      entiteLibelles: [],
      sitesLibelles: [],
      genresLibelles: [],
      naturesLibelles: [],
      endroitLibelles: [],
      typeLibelles: [],
      categorieLibelles: [],
      secteurLibelles: [],
      intervenantLibelles: [],
      regroupementLibelles: [],

      intervenantsLoading: false,
      critereRechercheRegroupement: {}
    };
  },

  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },

  methods: {
    setRegroupement(secteur) {
      this.$store.dispatch('narration/obtenirRegroupementAction', {
        libelleChange: 'TypeRegroupement',
        nouvelleValeur: [secteur]
      }).then((res) => {
        this.regroupementLibelles = res.data;
      });
    },
    assignerListe(entiteDecision) {
      this.entiteLibelles = entiteDecision.entite.libelles;
      this.secteurLibelles = entiteDecision.secteur.libelles;
      this.entite = this.entiteDefault;
      this.siteOrigine = this.siteDefault;
      for (let i = 0; i < this.secteurLibelles.length; i++) {
        if (this.secteurLibelles[i].texte == "Technicien surveillance") {
          this.secteur = this.secteurLibelles[i].valeur;
        }
      }
      this.dateDefault();
    },
    dateDefault() {
      let dateDefaut = new Date();
      this.dateDu = this.$commun.formatDate(dateDefaut.setDate(dateDefaut.getDate() - 7));
      this.dateAu = this.$commun.formatDate(new Date());
    },
    getCritereRecherche() {

      if (this.dateAu !== null && this.dateAu !== undefined) {
        this.critereRechercheRegroupement.dateAu = new Date(this.dateAu);
      }
      if (this.dateDu !== null && this.dateDu !== undefined) {
        this.critereRechercheRegroupement.dateDu = new Date(this.dateDu);
      }

      this.critereRechercheRegroupement.categorie = this.categorie;
      this.critereRechercheRegroupement.endroit = this.endroit;
      this.critereRechercheRegroupement.entite = this.entite;
      this.critereRechercheRegroupement.genre = this.genre;
      this.critereRechercheRegroupement.intervenant = this.intervenant;
      this.critereRechercheRegroupement.nature = this.nature;
      this.critereRechercheRegroupement.secteur = this.secteur;
      this.critereRechercheRegroupement.siteOrigine = this.siteOrigine;
      this.critereRechercheRegroupement.type = this.type;
      this.critereRechercheRegroupement.rapportPackage = "regroupement";

      return this.critereRechercheRegroupement;
    },
    imprimer() {
      this.$emit("imprimer");
    },
  },

  watch: {
    entite: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch("narration/onChangeEntityAction", {
          libelleChange: 'Site',
          nouvelleValeur: val
        })
            .then((res) => {
              this.sitesLibelles = res.data;
            });
        this.$store.dispatch('narration/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Genre',
          nouvelleValeur: val
        })
            .then((res) => {
              this.genresLibelles = res.data;
            });
      } else {
        this.genre = null;
        this.genresLibelles = [];
        this.siteOrigine = null;
        this.sitesLibelles = [];
      }
    },
    siteOrigine: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('narration/obtenirEndroitLocalisationParSiteAction', {
          site: val
        })
            .then((res) => {
              this.endroitLibelles = res.data.endroit;
            });
      } else {
        this.endroitLibelles = [];
        this.endroit = null;
      }
    },
    genre: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('narration/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Nature',
          nouvelleValeur: val
        })
            .then((res) => {
              this.naturesLibelles = res.data;
            });
      } else {
        this.nature = null;
        this.naturesLibelles = [];
      }
    },
    nature: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('narration/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Type',
          nouvelleValeur: val
        })
            .then((res) => {
              this.typeLibelles = res.data;
            });
      } else {
        this.type = null;
        this.typeLibelles = [];
      }
    },
    type: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('narration/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Categorie',
          nouvelleValeur: val
        })
            .then((res) => {
              this.categorieLibelles = res.data;
            });
      } else {
        this.categorie = null;
        this.categorieLibelles = [];
      }
    },
    secteur: function (val) {
      if (val !== null && val !== undefined) {
        this.intervenantsLoading = true;
        this.$store.dispatch('narration/obtenirListeIntervenantsAction', {
          secteur: val
        })
            .then((res) => {
              this.intervenantLibelles = res.data.sort(this.$commun.compareIntervenant);
              this.intervenantsLoading = false;
            })
        this.$store.dispatch('narration/obtenirRegroupementAction', {
          secteur: val
        }).then((res) => {
          this.regroupementLibelles = res.data;
        });
      } else {
        this.intervenant = null;
        this.intervenantLibelles = [];
        this.regroupement = null;
        this.regroupementLibelles = [];
      }
    },
  }
}
</script>